'use client';

import { DashboardScreen, LandingScreen } from "@/screens";

export default function HomePage() {
  return <DashboardScreen />;
  // return <LandingScreen/>
}
